<template>
	<div class="wrapper" @click="OnClick">
		{{ loading ? '加载中...' : '点击加载更多' }}
	</div>
</template>

<script>
export default {
	name: 'CllLoadMore',
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		OnClick() {
			if (!this.loading) {
				this.$emit('load-more');
			}
		},
	},
};
</script>

<style scoped>
.wrapper {
	width: 100%;
	height: 40px;
	line-height: 40px;
	display: block;
	text-align: center;
	font-size: 14px;
	color: rgba(153, 153, 153, 1);
	margin-bottom: 50px;
}
</style>
